import { ReactNode } from "react";
import { Stack } from "@mui/material";
import { Heading } from "src/api/sure-api/ssq/useGetOneSsq";
import { ScoresSection } from "src/components/QuestionnairesList/Scores/ScoresSection";
import { QuestionnairesList } from "src/components/QuestionnairesList/QuestionnairesList";
import { ANSWER_SSQ, COMPANY, useFoodpilotContext } from "src/context/FoodpilotContext";
import { getScoreIdsByType } from "src/utils/scores";
import { ScoreProvider } from "src/context/ScoreContext";
import { URLHandler } from "src/services/URLHandler";
import { getVisibleHeadings } from "src/utils/ssq";
import { useTranslation } from "react-i18next";
import { useCompanyMetadata } from "src/context/Company/Metadata/useCompanyMetadata";
import { useCompanyScores } from "src/context/Company/Scores/useCompanyScores";

export const Questionnaire = (): ReactNode => {
    const { scoreTypes, canUser } = useFoodpilotContext();
    const { company } = useCompanyMetadata();
    const {
        ssq: { post, ssq, isSsqFetched, isPostFetched },
    } = useCompanyScores();

    const { t } = useTranslation();

    const companyScoresIds = getScoreIdsByType("company", scoreTypes);

    const visibleHeadings = ssq && getVisibleHeadings(ssq, post?.hiddenElements);

    return (
        <>
            <Stack gap="60px">
                <Stack gap="28px">
                    <QuestionnairesList
                        ssq={ssq}
                        post={post}
                        isSsqLoading={isSsqFetched === false}
                        isPostLoading={isPostFetched === false}
                        completeQuestionnaireUrl={(heading: Heading) => {
                            const url = URLHandler.company.ssqHeading(company.id, heading.id);
                            return url;
                        }}
                        scoresSection={
                            <ScoreProvider type="company" formattedScores={post?.formattedScores}>
                                <ScoresSection post={post} headings={visibleHeadings} scoresIds={companyScoresIds} />
                            </ScoreProvider>
                        }
                        canEdit={canUser(ANSWER_SSQ, COMPANY)}
                    />
                </Stack>
            </Stack>
        </>
    );
};
